import { ImageTransitionBuilders } from "../ImageTransitionBuilder/ImageTransitionBuilder.ts";
import { TransitionSeries } from "@remotion/transitions";
import ImageTransitionWrapper from "../ImageTransitionBuilder/ImageTransitionWrapper.tsx";
import { AbsoluteFill, useVideoConfig } from "remotion";
import { Video } from "@remotion/media";
import { msToFrames } from "../../utils/timing.ts";
import {
  ImageTransitionCompositionProps,
  PREVIEW_CLIP_URLS,
} from "../../ImageTransitionComposition.tsx";

export default function ImageTransitionPreview({
  transition,
  clip1DurationInFrames,
  clip2DurationInFrames,
}: ImageTransitionCompositionProps) {
  const { fps } = useVideoConfig();
  const ImageTransitionBuilder = ImageTransitionBuilders.get(transition.kind);

  if (!ImageTransitionBuilder) {
    throw new Error(
      `ImageTransitionBuilder not found for kind: ${transition.kind}`,
    );
  }

  const transitionConfig = ImageTransitionBuilder.transition;

  return (
    <TransitionSeries from={0}>
      <TransitionSeries.Sequence durationInFrames={clip1DurationInFrames}>
        <ImageTransitionWrapper
          entryTransition={null}
          exitTransition={transition}
          durationInFrames={clip1DurationInFrames}
        >
          <AbsoluteFill>
            <Video src={PREVIEW_CLIP_URLS[0]!} className="h-full w-full" />
          </AbsoluteFill>
        </ImageTransitionWrapper>
      </TransitionSeries.Sequence>

      {!!transitionConfig && (
        <TransitionSeries.Transition
          presentation={transitionConfig.buildPresentation({
            imageTransition: transition,
            fps,
          })}
          timing={transitionConfig.buildTiming({
            imageTransition: transition,
            fps,
          })}
        />
      )}
      <TransitionSeries.Sequence
        durationInFrames={clip2DurationInFrames}
        premountFor={msToFrames(1000, fps)}
      >
        <ImageTransitionWrapper
          entryTransition={transition}
          exitTransition={null}
          durationInFrames={clip2DurationInFrames}
        >
          <AbsoluteFill>
            <Video
              src={PREVIEW_CLIP_URLS[1]!}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: 1080,
                height: 1080,
              }}
            />
          </AbsoluteFill>
        </ImageTransitionWrapper>
      </TransitionSeries.Sequence>
    </TransitionSeries>
  );
}
